import { FileDown } from "lucide-react";
import { PRODUCT_DOCUMENTS } from "../lib/site";

export const ProductDocumentDownloads = () => (
  <>
    {PRODUCT_DOCUMENTS.map((document) => (
      <a
        key={document.filename}
        href={`/documents/${document.filename}`}
        download={document.filename}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={document.testId}
        className="inline-flex items-center gap-2 border border-charcoal/30 hover:border-charcoal text-charcoal font-semibold px-6 py-3.5 text-sm tracking-wide transition-colors duration-300"
      >
        <FileDown className="w-4 h-4 shrink-0" />
        {document.label}
      </a>
    ))}
  </>
);